import { useMutation } from "@tanstack/react-query";
import { AXIOS_RESERVATION } from "../utils/axios-interceptors";
import { IUseUpdateOfferMutationResponse } from "../utils/types";
import { queryClient } from "../App";

const useUpdateOfferTemplate = (): IUseUpdateOfferMutationResponse =>
  useMutation({
    mutationFn: async ({ data, id }: any) => {
      const response = await AXIOS_RESERVATION.put(
        `v1/coupons/templates/${id}`,
        data
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.refetchQueries({ queryKey: ["offer-templates"] });
    },
  });

export default useUpdateOfferTemplate;
